import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import WhatsAppButton from '../components/layout/WhatsAppButton';
import Projects from '../components/sections/Projects';
import { QuoteDialog } from '../components/Modals';
import { listItems } from '../api';
import { ChevronRight, Home as HomeIcon } from 'lucide-react';

export default function ProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [quoteOpen, setQuoteOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    listItems('projects').then(setProjects).catch(() => {});
  }, []);

  return (
    <div className="bg-white min-h-screen" data-testid="projects-page">
      <Header onQuote={() => setQuoteOpen(true)} />

      <div className="pt-24 pb-0">
        <div className="egea-container">
          <nav className="flex items-center gap-2 text-[13px] text-slate-500">
            <Link to="/" className="flex items-center gap-1 hover:text-[#f5a524] transition-colors">
              <HomeIcon size={14} /> Acasă
            </Link>
            <ChevronRight size={14} className="text-slate-300" />
            <span className="text-slate-900 font-medium">Proiecte</span>
          </nav>
        </div>
      </div>

      <section className="pt-8 pb-4 border-b border-slate-200">
        <div className="egea-container">
          <span className="section-eyebrow">Portofoliu</span>
          <h1 className="font-display font-black uppercase tracking-tight text-slate-900 text-4xl md:text-6xl leading-[1] mt-3">
            Proiecte livrate
          </h1>
          <p className="mt-5 mb-8 text-base text-slate-600 max-w-[560px] leading-relaxed">
            De la reabilitări de blocuri la rafinării și monumente istorice — lucrări realizate cu echipe autorizate EGEA.
          </p>
        </div>
      </section>

      <Projects projects={projects} />

      <Footer />
      <WhatsAppButton />
      <QuoteDialog open={quoteOpen} onClose={() => setQuoteOpen(false)} prefillProduct={null} />
    </div>
  );
}
